import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../services/alert.service';

@Component({
  selector: 'cricteams-alert-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert-banner.component.html',
  styleUrls: ['./alert-banner.component.scss'],
})
export class AlertBannerComponent {
  @Input() message!: string;
  @Input() isError!: boolean;
  @Input() isSuccess!: boolean;

  constructor(private alertService: AlertService){}

  handleClose(){
    if(this.isSuccess){
      this.alertService.isSuccess.next(false);
    }
    if(this.isError){
      this.alertService.isError.next(false);
    }
  }
}
